import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { ISlideshowConfigResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { computed, toValue } from "vue"
import { v1 } from "@/axios"
import { SlideshowVideoJob } from "@/models"

const POLL_INTERVAL_MS = 10000

export async function getSlideshowVideo(id: string, eventVaultId: number) {
  const endpoint = `/${eventVaultId}/slideshow/${id}`

  const response = await v1.get<ServerResponseV1<ISlideshowConfigResponse>>(endpoint, { params: { include: "video" } })

  const video = response.data.data?.video

  return SlideshowVideoJob.fromResponse(video)
}

const GET_SLIDESHOW_VIDEO = "getSlideshowVideo"

export function useGetSlideshowVideo(
  id?: MaybeRef<string | undefined>,
  eventVaultId?: MaybeRef<number | undefined>,
  options: { enabled?: MaybeRef<boolean> } = {},
) {
  return useQuery({
    queryKey: [GET_SLIDESHOW_VIDEO, id, eventVaultId],
    queryFn: () => getSlideshowVideo(toValue(id)!, toValue(eventVaultId)!),
    enabled: computed(() => !!toValue(id) && !!toValue(eventVaultId) && (toValue(options.enabled) ?? true)),
    refetchInterval: query => (query.state.data?.isInProgress ? POLL_INTERVAL_MS : false),
    retry: false,
  })
}
